package com.macrofocus.high_d.axis

import com.macrofocus.slider.BoundedIntervalRangeSliderAdapter
import com.macrofocus.slider.RangeSliderModel
import com.macrofocus.slider.RangeSliderView
import org.mkui.component.CPComponentWrapper

abstract class AbstractAxisView<Row, C>(val rangeSliderView: RangeSliderView) :  CPComponentWrapper(rangeSliderView),AxisView<Row, C> {
    override var model: AxisModel<Row, C>? = null
        get() { return field }
        set(value) {
            field = value
            rangeSliderModel = BoundedIntervalRangeSliderAdapter(model!!.scaledInterval)
            rangeSliderView!!.setModel(rangeSliderModel)
        }

    protected var rangeSliderModel: RangeSliderModel? = null
}